export default "__VITE_ASSET__BTEOZqnv__"